const { ASYNC } = require('../utils/redux-helpers');

module.exports = {
    GET_USER_STATS: ASYNC,
    GET_MESSAGES_STATS: ASYNC
};
